/**
 * Katalog etiketleri (Story 19.1 / 19.2). Sunucu METİN GÖNDERMEZ — kod gönderir,
 * ad burada çeviri anahtarına çevrilir ve çağıran kendi dilinde basar.
 * Web ve mobil AYNI anahtarı kullanır; ad iki yerde çoğaltılmaz.
 */
export function cityLabelKey(code) {
    return `catalog.city.${code}`;
}
export function ticketKindLabelKey(kind) {
    return `catalog.ticketKind.${kind}`;
}
/** Kart alanı etiketleri (rapor §7 görünüm modeli; sözlük `sector.*`, `seniority.*`). */
export function sectorLabelKey(value) {
    return `sector.${value}`;
}
export function seniorityLabelKey(value) {
    return `seniority.${value}`;
}
/**
 * SATIŞ DURUMU ETİKETİ. Ad `manage.*` altındadır çünkü durum yalnız ORGANİZATÖR
 * yüzeylerinde görünür (katılımcı gizli/kapalı türü hiç görmez), ama eşleme
 * BURADA durur: web paneli ve mobil panel aynı üç sözcüğü söylemek zorunda.
 * Kayıt `Record<TicketStatus, …>` — kümeye yeni bir durum eklenirse DERLEME
 * KIRILIR ve etiket beyansız kalamaz.
 */
const TICKET_STATUS_LABEL_KEYS = {
    active: 'manage.ticketStatusActive',
    hidden: 'manage.ticketStatusHidden',
    closed: 'manage.ticketStatusClosed',
};
export function ticketStatusLabelKey(status) {
    return TICKET_STATUS_LABEL_KEYS[status];
}
/** `null` şehir (çevrimiçi etkinlik) için etiket üretmez. */
export function cityLabel(code, translate) {
    return code ? translate(cityLabelKey(code)) : null;
}
export function ticketKindLabel(kind, translate) {
    return kind ? translate(ticketKindLabelKey(kind)) : null;
}
/**
 * E-POSTA ŞABLONU ETİKETİ (panel · gönderim görünümü).
 *
 * `Record<EmailTemplateKey, TranslationKey>`: katalogda yeni bir şablon
 * açıldığında DERLEME KIRILIR ve etiket beyansız kalamaz. Şablon anahtarı
 * ekrana HAM basılmaz — personel `card_exchange_confirmed` değil "Kartvizit
 * değişimi onaylandı" okur.
 */
const EMAIL_TEMPLATE_LABEL_KEYS = {
    otp_login: 'admin.emailDeliveries.templates.otp_login',
    registration_confirmed: 'admin.emailDeliveries.templates.registration_confirmed',
    event_invitation: 'admin.emailDeliveries.templates.event_invitation',
    application_result: 'admin.emailDeliveries.templates.application_result',
    event_updated: 'admin.emailDeliveries.templates.event_updated',
    event_cancelled: 'admin.emailDeliveries.templates.event_cancelled',
    team_invitation: 'admin.emailDeliveries.templates.team_invitation',
    claim_owner_notice: 'admin.emailDeliveries.templates.claim_owner_notice',
    claim_decision: 'admin.emailDeliveries.templates.claim_decision',
    claim_transferred: 'admin.emailDeliveries.templates.claim_transferred',
    claim_info_request: 'admin.emailDeliveries.templates.claim_info_request',
    data_export_ready: 'admin.emailDeliveries.templates.data_export_ready',
    account_deletion_confirmed: 'admin.emailDeliveries.templates.account_deletion_confirmed',
    speaker_link_request: 'admin.emailDeliveries.templates.speaker_link_request',
    invitation_request: 'admin.emailDeliveries.templates.invitation_request',
    meeting_request_received: 'admin.emailDeliveries.templates.meeting_request_received',
    meeting_request_accepted: 'admin.emailDeliveries.templates.meeting_request_accepted',
    meeting_request_declined: 'admin.emailDeliveries.templates.meeting_request_declined',
    meeting_request_cancelled: 'admin.emailDeliveries.templates.meeting_request_cancelled',
    organization_verification_decision: 'admin.emailDeliveries.templates.organization_verification_decision',
    card_exchange_confirmed: 'admin.emailDeliveries.templates.card_exchange_confirmed',
    follow_up_reminder: 'admin.emailDeliveries.templates.follow_up_reminder',
    staff_login_code: 'admin.emailDeliveries.templates.staff_login_code',
    staff_invitation: 'admin.emailDeliveries.templates.staff_invitation',
    email_verification: 'admin.emailDeliveries.templates.email_verification',
    password_reset: 'admin.emailDeliveries.templates.password_reset',
    account_exists_notice: 'admin.emailDeliveries.templates.account_exists_notice',
    event_ceiling_warning: 'admin.emailDeliveries.templates.event_ceiling_warning',
    organizer_announcement: 'admin.emailDeliveries.templates.organizer_announcement',
    event_report_ready: 'admin.emailDeliveries.templates.event_report_ready',
    post_event_message: 'admin.emailDeliveries.templates.post_event_message',
    event_reminder: 'admin.emailDeliveries.templates.event_reminder',
};
export function emailTemplateLabelKey(template) {
    return EMAIL_TEMPLATE_LABEL_KEYS[template];
}
//# sourceMappingURL=catalog-text.js.map